import { useContext } from 'react';
import KeycloakContext, { KeyCloakContextType } from '../contexts/KeycloakContext';


const useAuth = () => {
  return  useContext<KeyCloakContextType>(KeycloakContext);
};

export default useAuth;
